import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";
import CustomTable from 'components/table';
import { ActionMenu, ButtonGroup, CustomButton } from 'components';
import { masterPaginationServices, tableInitialState, } from 'utils/constants';
import { getTableParams } from 'utils/global';
import PageLayout from 'layouts/PageLayout';
import { RemoveRedEye } from '@mui/icons-material';
import { getMasterPaginationData } from 'redux/actions';
import { RootReducerState } from 'utils/types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import FdaDrugViewModal from './FdaDrugViewModal';

const fdaDrugsColumns = (formatMessage: any) => [
    {
        label: formatMessage({ id: "application-no" }),
        name: "appl_no",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        label: formatMessage({ id: "drug-name" }),
        name: "drug_name",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        label: formatMessage({ id: "strength" }),
        name: "strength",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        label: formatMessage({ id: "sponsor" }),
        name: "sponsor",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        label: formatMessage({ id: "active-ingredient" }),
        name: "active_ingredient",
        options: {
            filter: true,
            sort: true,
        }
    },
];

const FdaDrugs: React.FC = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    const [tableState, setTableState] = useState(tableInitialState);
    const [viewModal, setViewModal] = useState<boolean>(false);
    const [selectedData, setSelectedData] = useState<any>(null);

    useEffect(() => {
        onApiCall();
    }, [tableState]);

    function onApiCall() {
        const params = getTableParams(tableState);
        dispatch(getMasterPaginationData(masterPaginationServices.fdaDrugs, params));
    }


    const { userData, loading } = useSelector(
        ({ masterPaginationReducer }: RootReducerState) => ({
            userData: masterPaginationReducer[masterPaginationServices.fdaDrugs].data,
            loading: masterPaginationReducer[masterPaginationServices.fdaDrugs].loading,
        }),
        shallowEqual
    );

    const { items, count } = userData;


    const columnAction = {
        label: formatMessage({ id: "action" }),
        name: "",
        options: {
            customBodyRender: (_: any, tableMeta: any) => {
                const rowData = items[tableMeta.rowIndex];
                return (
                    <ButtonGroup>
                        <CustomButton
                            color='primary'
                            size='small'
                            label={formatMessage({ id: "view" })}
                            variant='outlined'
                            onClick={() => handleRowClick(rowData)}
                            startIcon={<RemoveRedEye />}
                        />
                    </ButtonGroup>
                )
            }
        }
    };

    const handleRowClick = (rowData: any): void => {
        setViewModal(true);
        setSelectedData(rowData);
    };

    return (
        <PageLayout title={formatMessage({ id: "fda-drugs" })} hideToolbar>
                <CustomTable
                columns={[columnAction, ...fdaDrugsColumns(formatMessage)]}
                tableData={items}
                tableState={tableState}
                itemsCount={count}
                setTableState={setTableState}
                loading={loading}
            />
           
            {viewModal && selectedData &&
                <FdaDrugViewModal
                    open={viewModal}
                    onClose={() => setViewModal(false)}
                    selectedData={selectedData}
                />
            }
        </PageLayout>
    )
};

export default FdaDrugs;